module.exports = __webpack_public_path__ + "img/areaBlueOrder.73621452.png";